
// import { GoogleAnalytics, GoogleAnalyticsOriginal } from '@awesome-cordova-plugins/google-analytics';
import { isPlatform } from '@ionic/react';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';

declare global {
  interface Window {
    gtag?: (
      key: string,
      trackingId: string,
      config: { page_title?: string, page_path?: string, send_page_view?: boolean }
    ) => void
  }
}

export interface IAnalyticsService {
    trackingId: string,
    initAnalyticsLog: () => void,
    hybridPageLog: (path: string, title?: string) => void,
    webPageLog: (path: string) => void,
    }

const AnalyticsService: IAnalyticsService = {

  trackingId: 'G-CFKCRWGDD5',

  initAnalyticsLog: () => {
    if(isPlatform('hybrid')){
      FirebaseAnalytics.logEvent({name: 'page_view', params: { page_title: 'App Started', page_path: '/appStarted' }});
    } else {
      if (!window.gtag) {return}
      window.gtag('config', AnalyticsService.trackingId, { send_page_view: false });
      window.gtag('config', AnalyticsService.trackingId, { page_title: 'App Started', page_path: '/appStarted' });
    }  
  },
  
  hybridPageLog: (path) => {
    // the screen capture event should be fired whenever a new page is displayed, but this is added till we prove other is working properly
    console.log('loggingScreen:', path);
    FirebaseAnalytics.logEvent({name: 'page_view', params: { page_title: path, page_path: path }});
  },

  webPageLog: (path) => {
    if (!window.gtag) {return}
    console.log('loggingPage:', path);
    window.gtag('config', AnalyticsService.trackingId, { page_title: path, page_path: path, send_page_view: false });
  }
}

export default AnalyticsService;